import { auth } from "../firebase";

export const SendVerificationEmail = (): void => {
  const user = auth.currentUser;
  if (user) {
    user.sendEmailVerification();
  }
};
